import React from 'react';
import { Link } from 'react-router-dom';

const Privacy = () => {
  return (
    <div className="bg-[#f1f0ee] font-semibold text-[#1f1f1f] font-serif min-h-screen flex flex-col justify-between overflow-x-hidden">

      {/* Grid background */}
      <div
        className="pointer-events-none absolute inset-0 z-0"
        style={{
          backgroundImage: `
              linear-gradient(to right, #ddd 1px, transparent 1px),
              linear-gradient(to bottom, #ddd 1px, transparent 1px)
            `,
          backgroundSize: "32px 32px",
          opacity: 1,
          maskImage: "radial-gradient(circle at center, white, transparent 75%)",
          WebkitMaskImage: "radial-gradient(circle at center, white, transparent 75%)"
        }}
        aria-hidden="true"
      />

      {/* Top bar */}
      <div className="bg-white/50 shadow-lg h-14 md:h-16 md:w-full max-w-[1000px] z-30 mt-3 md:m-4 md:mx-auto px-3 md:px-4 border border-[#383838]/20 rounded-2xl md:rounded-3xl mx-3">
        <div className="flex h-full items-center justify-between">
          <Link to="/" className="min-w-0">
            <div className="flex items-center">
              <img src="images/lrc_icon.png" alt="LearnRussianCases icon" className="w-7 h-7 md:w-8 md:h-8 rounded-full mr-2" />
              <p className="text-[#1f1f1f] font-nunito text-lg md:text-2xl truncate">LearnRussianCases</p>
            </div>
          </Link>

          <div className="flex flex-row gap-x-4 md:gap-x-8">
            <Link to="/support"><p className="text-[#1f1f1f] font-nunito text-sm md:text-lg">Support</p></Link>
            <Link to="/privacy"><p className="text-[#1f1f1f] font-nunito text-sm md:text-lg">Privacy</p></Link>
          </div>
        </div>
      </div>

      {/* Headline */}
      <div className="mt-6 md:mt-8 mx-auto z-30 w-full md:w-auto max-w-[1000px] px-4">
        <h1 className="font-bebas tracking-wide mb-6 md:mb-0 text-7xl md:text-8xl text-center md:text-left leading-none">
          Privacy
        </h1>
      </div>

      {/* Privacy Policy */}
      <main id="seo-content" className="z-30 w-full mt-6 md:mt-10 mb-12 md:mb-20">
        <section id="privacy-policy" aria-labelledby="privacy-policy-title" className="m-4 md:m-0">
          <h2
            id="privacy-policy-title"
            className="font-bebas text-4xl md:text-5xl w-full md:w-[1000px] mx-auto tracking-wide mb-3 md:mb-4 md:pl-8 text-center md:text-left"
          >
            Privacy Policy
          </h2>

          <div className="relative bg-white/50 shadow-lg w-full md:w-[1000px] z-30 m-4 mx-auto p-6 border border-[#383838]/20 rounded-3xl">
            <img
              src="images/doll_head_smiling.png"
              alt="Smiling matryoshka doll"
              className="hidden md:block absolute w-24 h-24 -top-24 right-8"
            />

            <div className="font-nunito leading-7">
              <p className="mb-4 opacity-60">
                <strong>Effective date:</strong> 30 October 2025
              </p>

              <p>
                This Privacy Policy explains how the LearnRussianCases app (“we”, “us”, “our”) handles your
                information. We do <strong>not</strong> serve ads and we do <strong>not</strong> sell your data.
              </p>

              <h3 className="font-semibold mt-8">1) What we collect</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>App data is kept on your device.</strong> Your lesson progress, settings, and preferences are stored locally on your device.</li>
                <li><strong>Optional analytics.</strong> If you consent, we collect anonymised usage data (e.g., screens viewed, feature usage, crash/diagnostic events) via Google Analytics to help us improve the app.</li>
                <li><strong>No account required.</strong> We don’t require you to create an account to use the app.</li>
              </ul>

              <h3 className="font-semibold mt-8">2) How we use information</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide core features (lessons, practice, progress tracking).</li>
                <li>Improve reliability and user experience based on aggregated analytics (only if enabled).</li>
              </ul>

              <h3 className="font-semibold mt-8">3) Analytics and your choices</h3>
              <p>
                Analytics tracking is <strong>optional</strong>. You can enable/disable analytics at any time in the
                app’s <em>Settings</em>. If disabled, no analytics events are sent.
              </p>

              <h3 className="font-semibold mt-8">4) Data sharing</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>We do <strong>not</strong> share your personal data with advertisers.</li>
                <li>When enabled, analytics data is processed by Google (Google Analytics/Firebase). Google may process data on servers outside your country. See Google’s privacy policies for details.</li>
              </ul>

              <h3 className="font-semibold mt-8">5) Legal basis (UK/EU)</h3>
              <p>
                For UK/EU users, our legal basis for optional analytics is <strong>consent</strong>. You may withdraw consent in Settings at any time.
              </p>

              <h3 className="font-semibold mt-8">6) Data retention</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>On-device app data remains on your device until you delete the app or reset data.</li>
                <li>If analytics is enabled, aggregated analytics data is retained by Google per their standard retention schedules.</li>
              </ul>
            </div>
          </div>
        </section>
      </main>

      <div className='flex-1'></div>

      {/* Footer */}
      <footer className="bg-white/50 shadow-lg h-14 md:h-16 md:w-full max-w-[1000px] z-30 mx-3 md:m-4 mb-4 md:mb-8 md:mx-auto px-4 border border-[#383838]/20 rounded-2xl md:rounded-3xl">
        <div className="flex h-full items-center justify-center">
          <a href="https://josephmalam.com/" target="_blank" className="font-nunito px-2 text-sm md:text-base" rel="noopener noreferrer">
            &copy; <span className='underline decoration-[#1f1f1f]/50'>Joseph</span> and Anna Malam 2022-2025
          </a>
        </div>
      </footer>
    </div>
  );
};

export default Privacy;
